export enum PessoaTipoEnum {
  PF = 'PF',
  PJ = 'PJ'
}
